export default function About() {
  return (
    <section id="about" className="about-section" aria-label="Über La Jolie Vie">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">Über La Jolie Vie</h2>
            <br />
            <p>
            La Jolie Vie ist aus der tiefen Überzeugung entstanden, dass jeder Hund eine ruhige, 
            respektvolle und liebevolle Pflege verdient.
            <br />
            <br />
            Für mich ist Grooming nicht nur ein Beruf, sondern eine bewusste Entscheidung, mit Geduld, 
            Feingefühl und fachlicher Kompetenz zu arbeiten.
            <br />
            <br />
            Ich bin mit Hunden und anderen Tieren aufgewachsen, und die Liebe sowie der respektvolle 
            Umgang mit ihnen begleiten mich seit meiner Kindheit. Vor über zehn Jahren kam Joli, ein 
            Cavalier King Charles Welpe, in mein Leben, den eine enge Freundin adoptiert hat. Durch sie 
            wurde mir noch bewusster, wie sensibel, feinfühlig und emotional Hunde sind und wie wichtig Ruhe, 
            Verständnis und Vertrauen in der Pflege sind. In dieser Zeit reifte meine Entscheidung, diesen 
            Weg auch professionell zu gehen.
            <br />
            <br />
            Jeder Hund ist einzigartig mit seinem eigenen Charakter, seinem Tempo und seinen individuellen 
            Bedürfnissen. Genau darauf gehe ich bei jeder Behandlung ein. Mein Ziel ist es, eine stressfreie 
            Umgebung zu schaffen, in der sich Ihr Vierbeiner sicher und wohlfühlt.
            Meine professionelle Ausbildung habe ich 2019 abgeschlossen, und 2025 mein Fachwissen durch eine 
            weitere Ausbildung gezielt vertieft, um meine Arbeit kontinuierlich weiterzuentwickeln. Großen Wert 
            lege ich auf eine professionelle, hygienische und hochwertige Pflege. Gleichzeitig steht für mich 
            immer das Wohl des Hundes an erster Stelle, ohne Hektik, ohne Zwang, mit viel Ruhe und Zeit.
            <br />
            <br />
            La Jolie Vie ist ein Ort, an dem Vertrauen, Qualität und Liebe zum Tier zusammenkommen.
            Für einen gepflegten, entspannten und glücklichen Hund.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
